import { render, staticRenderFns } from "./InvoiceIcon.vue?vue&type=template&id=29c156a7&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp7.4.1\\htdocs\\e2e-invoicing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29c156a7')) {
      api.createRecord('29c156a7', component.options)
    } else {
      api.reload('29c156a7', component.options)
    }
    module.hot.accept("./InvoiceIcon.vue?vue&type=template&id=29c156a7&", function () {
      api.rerender('29c156a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/InvoiceIcon.vue"
export default component.exports